<template>
  <profile-modal-base
    id="activation-modal"
    :is-open="showModal"
    data-test="activation-modal"
    @close="close"
  >
    <template #header>
      <profile-modal-header
        header-text="Enter Activation Code"
        :back-target="'accountModal'"
      >
      </profile-modal-header>
    </template>
    <activation :activators="activators" />
    <span class="flex-1"></span>
    <div class="button-row">
      <button class="button-reset button-basic" @click="back">
        Cancel
      </button>
      <button
        class="button-reset button-primary font-semibold"
        :disabled="disabled"
        @click="activate"
      >
        Activate Code
      </button>
    </div>
  </profile-modal-base>
</template>

<script>
import ProfileModalBase from './ProfileModalBase.vue';
import ProfileModalHeader from './ProfileModalHeader.vue';
import ProfileModalMixin from '@/mixins/profileModal';
import Activation from '@components/activation/show';
import ActivationMixin from '@/mixins/activation';

const ACTIVATION_EVENT = 'activation-code-change';
const MODAL_NAME = 'activationModal';

export default {
  name: 'ActivationModal',
  components: {
    Activation,
    ProfileModalBase,
    ProfileModalHeader,
  },
  mixins: [ActivationMixin, ProfileModalMixin],
  data() {
    return {
      activationCodes: {},
      disabled: false,
      errorMessage: null,
    };
  },
  computed: {
    activators() {
      return this.$store.getters['activation/activators'].filter(a => a.activatorType !== 'Ase');
    },
    showModal() {
      return this.$store.getters['ui/profileModalShown'] === MODAL_NAME;
    },
  },
  created() {
    this.$eventBus.$on(ACTIVATION_EVENT, this.updateActivationCodes);
  },
  beforeUnmount() {
    this.$eventBus.$off(ACTIVATION_EVENT);
  },
  methods: {
    activate() {
      if (this.disabled) return;
      this.showErrors = null;

      const params = {
        activationCodes: this.activationCodes,
      };

      this.disabled = true;

      this.$store.dispatch('activation/activateUser', params).then(results => {
        this.activationCodeNotifications(results);
        const error = results.find(result => !result.status);
        if (error) {
          this.errorMessage = (error.errors || [])[0] || 'Invalid Activation Code';
        }
      }).then(() => {
        this.back();
      }).finally(() => {
        this.disabled = false;
      });
    },
    back() {
      this.$store.commit('ui/setProfileModalShown', 'accountModal');
    },
    submitActivationCode() {
      console.log('Submitting activation codes:', this.activationCode1, this.activationCode2);
    },
  },
};
</script>
<style lang="scss">
#activation-modal {
  label {
    display: block;
  }

  input {
    padding: 0.75rem;
    background-color: white;
    border-radius: var(--radius-md);
    border: 1px solid var(--border-primary);
    margin-top: rem-calc(6);
    font-size: 1rem;
    color: #333;
  }
}
</style>

<style scoped lang="scss">
.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  gap: rem-calc(12);
}
</style>
